import { Button } from "antd";
import { useEffect } from "react";
import api from "../api/axios";
import { useView } from "../contexts/ViewContext";
import styles from "./Intro.module.css";

function Intro({ learningJourneyId, view }) {
    const { setOnAdvance, advance, advancing } = useView();

    useEffect(() => {
        const viewId = view.view_id;
        setOnAdvance(async () => {
            try {
                await api.post(`/workspace/intro/mark-complete/`, {
                    learning_journey_id: learningJourneyId,
                    view_id: viewId,
                });
            } catch (error) {
                console.error("Failed to mark intro complete:", error);
            }
        });
    }, [view.view_id, learningJourneyId, setOnAdvance]);

    // Unregister on unmount so a later, unrelated view's "Continue" click
    // can never fire this intro's completion call.
    useEffect(() => () => setOnAdvance(null), [setOnAdvance]);

    return (
        <div className={styles.wrapper}>
            <div className={styles.glow} />
            <div className={styles.container}>
                <div className={styles.block}>
                    <span className={styles.label}>Before you begin</span>
                    <h1 className={styles.headline}>This is how it sticks</h1>
                    <p className={styles.body}>
                        You'll solve problems before you've been taught how.
                        <br />
                        <span className={styles.emphasis}>Struggling is the point.</span> It means it's working.
                    </p>
                </div>
                <Button
                    type="primary"
                    size="large"
                    className={styles.action}
                    onClick={advance}
                    loading={advancing}
                >
                    Let's go
                </Button>
            </div>
        </div>
    );
}

export default Intro;
